var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('activaitor',{attrs:{"placeholder":"ابحث عن نشاط محدد","btnText":"نشاط جديد"},on:{"ok":function($event){return _vm.$router.push('/admin/activities/00000000-0000-0000-0000-000000000000')},"search":_vm.search}})}
var staticRenderFns = []

export { render, staticRenderFns }